import Box from '@mui/material/Box';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useCallback, useEffect, useState } from 'react';
import { HashRouter, Route, Routes } from "react-router-dom";
import './App.scss';
import Header from './components/Header/Header';
import Sidenav from './components/Sidenav/Sidenav';
import About from './components/views/pages/About/About';
import Dashboard from './components/views/pages/Dashboard/Dashboard';
import Login from './components/views/pages/Login/Login';
import MapView from './components/views/pages/MapView/MapView';
import Movements from './components/views/pages/Movements/Movements';
import Settings from './components/views/pages/Settings/Settings';
import TripsAgenda from './components/views/pages/Trips-Agenda/Trips-Agenda';

import axios from 'axios';
import _ from 'lodash';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useDispatch, useSelector } from "react-redux";
import Agenda from './components/views/common/Agenda/Agenda';
// import Agenda2 from './components/views/common/Agenda/Agenda2';
import CreateCustomView from './components/views/common/CreateCustomView/CreateCustomView';
import CustomViewTemplate from './components/views/common/CustomViewTemplate/CustomViewTemplate';
import Spinner from './components/views/common/Spinner/Spinner';
import Driver from './components/views/pages/Driver/Driver';
import PartialTrip from './components/views/pages/PartialTrip/PartialTrip';
import Profile from './components/views/pages/Profile/Profile';
import ShipmentMovements from './components/views/pages/ShipmentMovements/ShipmentMovements';
import SubContractor from './components/views/pages/SubContractor/SubContractor';
import Trailer from './components/views/pages/Trailer/Trailer';
import Trip from './components/views/pages/Trip/Trip';
import TripRoutes from './components/views/pages/TripRoutes/TripRoutes';
import VariousResource from './components/views/pages/VariousResource/VariousResource';
import VehicleResource from './components/views/pages/VehicleResource/VehicleResource';
import { loginReducer } from './shared/ReduxStore/Reducers/loginReducer';
import CompanyNotFound from './shared/common-utilities/CompanyNotFound/CompanyNotFound';
import UserNotFound from './shared/common-utilities/UserNotFound/UserNotFound';
import CustomError from './shared/common-utilities/customError/customError';
import CreateChannelService from './shared/common-utilities/services/CreateChannelService';
import commonApiService from './shared/common-utilities/services/commonApiService';

// import AgendaBigScheduler from './components/views/common/Agenda/AgendaBigScheduler';
// import 'devextreme/dist/css/dx.light.css';
import moment from 'moment';
import { setSchedulerTrayReducer } from "./shared/ReduxStore/Reducers/schedulerTrayReducer.jsx";
// import { Draggable as MsDraggable, Dropcontainer as MsDropcontainer, Eventcalendar, getJson, setOptions, Toast } from '@mobiscroll/react';
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import { guid } from '@progress/kendo-react-common';
import AgendaDemoMs from './components/views/common/Agenda/AgendaDemoMs';
import AgendaMsPlayGround from './components/views/common/Agenda/AgendaMsPlayGround';
import dataStorageService from './shared/common-utilities/services/DataStorageService';

import { AuthGuard } from './shared/common-utilities/common/AuthGuard';
import AgendaView from './components/views/pages/ResourceView/AgendaView.jsx';
import Resources from './components/views/pages/Resources/Resources.jsx';

const theme = createTheme({

  typography: {
    body2: {
      fontSize: 14,
    },
    body1: {
      fontSize: 12,
    },
    display1: {
      fontSize: 14,
    },
    title: {
      fontSize: 13,
    },
    subheading: {
      fontSize: 13,
    },

  },
  palette: {
    primary: {
      main: "#3B66B0",
      dark: "#000",
      contrastText: '#fff',
    },
    secondary: {
      // This is green.A700 as hex.
      main: '#64C6BB',
      dark: '#088A7C',
      contrastText: '#fff',
    },
    neutral: {
      main: '#C22EDA',
      contrastText: '#fff',
    },
    tertiary: {
      main: '#DEDDDE',
      light: '#ECECEC',
      contrastText: '#111111',
    },
    warning: {
      main: '#F4B600',
      light: '#FFD24F',
      contrastText: '#fff',
    },
    info: {
      main: '#9dc4dc',
      light: '#d7edfb',
      dlight: '#d7edfb',
      contrastText: '#fff',
    },
    danger: {
      main: '#D32727',
      light: '#EE6363',
      contrastText: '#fff',
    },
    plan: {
      main: '#f6f0fb',
      light: '#a66cd9',
      contrastText: '#a66cd9',
    },


  },
  breakpoints: {
    values: {
      xxs: 0, // smol phone
      xs: 300, // phone
      sm: 600, // tablets
      md: 900, // small laptop
      lg: 1200, // desktop
      xl: 1536 // large screens
    }
  },
  components: {
    MuiToolbar: {
      styleOverrides: {
        dense: {
          height: 45,
          minHeight: 45
        }
      }
    },

    MuiListItem: {
      // defaultProps: {
      //   dense: true,
      // },
      styleOverrides: {
        root: {
          // backgroundColor: 'blue',
          '.Mui-selected': {
            backgroundColor: '#64C6BB !important',
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          background: "linear-gradient(191deg, rgba(59,102,176,1) 0%, rgba(100,198,187,1) 100%)",
          color: "white",
          boxSizing: "border-box",
        }
      }
    }
  }
});


let apiService = commonApiService();

function App() {

  window.channelList = [];
  CreateChannelService().CreateChannel('DragDropChannel');

  const [isShow, setIsShowFlag] = useState(false);

  const [index, setIndex] = useState(0);
  const [movFilterFlag, setMovFilterFlag] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const isValid = localStorage.getItem("userID")
  const urlParams = new URLSearchParams(window.location.href.split('?')[1]); // Get the part of the URL after the '?'
  const code = urlParams.get('code');
  // localStorage.setItem('code', code)
  const accessToken = localStorage.getItem('accessToken');
  const [isAuthenticated, userHasAuthenticated] = useState(Boolean(accessToken));

  const dispatch = useDispatch()
  // const navigate = useNavigate()


  useEffect(() => {
    if (isAuthenticated) {

      const refreshToken = async () => {
        try {
          const refreshToken = localStorage.getItem("refreshToken");
          const tokenEndpoint = process.env.REACT_APP_TOKEN_URL

          await axios.post(tokenEndpoint, {
            grant_type: 'refresh_token',
            refresh_token: refreshToken,
          },
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                // 'Authorization': 'Basic NmQ4ZjdkMGEtYWNiZC00NGFlLWE3NDUtOWFmMmQ4OGRhYTkyOkppMzhRfmxXWDBFLWR3T25oTlQyNzdlbndIenA5SVNUb3hGdzZkcUs='
              },
            }
          ).then(res => {
            localStorage.setItem("accessToken", res.data.access_token)
            localStorage.setItem("refreshToken", res.data.refresh_token)
            localStorage.setItem("expires_on", res.data.expires_on)
          }).catch(err => {
            console.log(err);
            apiService.logOut();
            return
          });

        } catch (error) {
          apiService.logOut();
          console.error('Error refreshing token:', error.response ? error.response.data : error.message);
        }
      }
      const checkTokenExpire = () => {
        const currentTime = Math.floor(Date.now() / 1000);
        const expiresOn = localStorage.getItem("expires_on")
        const tokenTimeStamp = localStorage.getItem('tokenTimeStamp')
        const timeDifference = currentTime - parseInt(tokenTimeStamp ? tokenTimeStamp : 0, 10);

        // if(timeDifference >= 6 * 60 * 60 && tokenTimeStamp !== null) {
        //   localStorage.clear();
        //   window.location.reload();
        //   return
        // }
        if (currentTime + 600 >= expiresOn) {
          refreshToken()
        }
        setTimeout(checkTokenExpire, 1000);
      }

      if (code == null) {
        checkTokenExpire();
      }
    }

  }, [isAuthenticated])

  // --------------- common methods start ---------------
  const sideBarIndex = (data) => {
    setIndex(data);
  }

  const getMovementFilterFlag = (data) => {
    setMovFilterFlag(data.movementFilterFlag);
    setIndex(data.index);
  }
  // --------------- common methods end ---------------
  return (
    <>
      {isLoading ? (<Spinner />) : (<></>)}
      <DndProvider backend={HTML5Backend}>
        <ThemeProvider theme={theme}>
          <HashRouter basename=''>
            {isAuthenticated && isValid !== null && <Header index={index} setMovementFilterFlag={getMovementFilterFlag} />}
            <Box height={45} sx={{ minHeight: '50px' }} />
            {/* <Box sx={{ display: 'flex' }}> */}
            <Box sx={{ display: 'flex', maxHeight: 'calc(100% - 45px)' }}  >
              {isAuthenticated && isValid !== null &&
                <Sidenav sideBarIndex={sideBarIndex} />
              }
              <Routes>
                <Route path='/login' element={<Login />}></Route>
                <Route path='' element={isAuthenticated ? <Dashboard /> : <Login authCode={code} />}></Route>
                <Route path='/' element={isAuthenticated ? <Dashboard /> : <Login authCode={code} />}></Route>
                <Route element={<AuthGuard />}>
                  <Route path='/dashboard' element={<Dashboard />}></Route>
                  {/* <Route path='/login' element={!isAuthenticated ? <Dashboard /> : <Navigate to='/login' />}></Route> */}
                  <Route path="/movements" element={<Movements movFilterFlag={movFilterFlag} routeName={'/movements'} />}></Route>
                  <Route path='/map' element={<MapView />}></Route>
                  <Route path='/about' element={<About />}></Route>
                  <Route path='/settings' element={<Settings />}></Route>
                  <Route path='/agenda' element={<TripsAgenda />}></Route>
                  <Route path='/trip' element={<Trip routeName={'/trip'} />}></Route>
                  {/* <Route path='/scheduler'  element={<Scheduler></Scheduler>}></Route> */}
                  {/* <Route path='/partial-trip' element={<PartialTripRoute Header={'Partial trip'} routeName={'/partial-trip'} />}></Route> */}
                  <Route path='/partialtrip' element={<PartialTrip Header={'Partial trip'} routeName={'/partialtrip'} />}></Route>
                  <Route path='/route' element={<TripRoutes Header={'Route'} routeName={'/route'} />}></Route>
                  <Route path='/shipment-movements' element={<ShipmentMovements Header={'Shipment Movements'} routeName={'/shipment-movements'} />}></Route>
                  <Route path='/trip-agenda' element={<Agenda Header={'Trip Agenda'} routeName={'/trip-agenda'} isCrossIcon={true} />}></Route>
                  <Route path='/trip-agenda-kendo' element={<Agenda Header={'Trip Agenda'} routeName={'/trip-agenda'} isCrossIcon={true} />}></Route>
                  {/* <Route path='/trip-agenda-kendo2' element={<Agenda2 Header={'Trip Agenda'} routeName={'/trip-agenda'} isCrossIcon={true} /> }></Route> */}
                  {/* <Route path='/trip-agenda-dx' element={<AgendaDemo Header={'Trip Agenda'} routeName={'/trip-agenda'} isCrossIcon={true} /> }></Route> */}
                  <Route path='/trip-agenda-ms' element={<AgendaDemoMs Header={'Trip Agenda'} routeName={'/trip-agenda'} isCrossIcon={true} />}></Route>
                  <Route path='/trip-agenda-ms-pg' element={<AgendaMsPlayGround Header={'Trip Agenda'} routeName={'/trip-agenda'} isCrossIcon={true} />}></Route>
                  <Route path='/agenda-view' element={<AgendaView Header={'Agenda View'} routeName={'/agenda-view'} isCrossIcon={true} />}></Route>
                  <Route path='/CustomView' element={<CustomViewTemplate Header={'Custom View'} routename={'/CustomView'} />}></Route>
                  <Route path='/CreateCustomView' element={<CreateCustomView Header={'Create Custom View'} routename={'/CreateCustomView'} />}></Route>
                  <Route path='/vehicle-resource' element={<VehicleResource Header={'Vehicle Resource'} routeName={'/vehicle-resource'} />}></Route>
                  <Route path='/driver' element={<Driver Header={'Driver'} routeName={'/driver'} />}></Route>
                  <Route path='/subContractor' element={<SubContractor Header={'SubContractor'} routeName={'/subContractor'} />}></Route>
                  <Route path='/trailer' element={<Trailer Header={'Trailer'} routeName={'/trailer'} />}></Route>
                  <Route path='/various-resource' element={<VariousResource Header={'VariousResource'} routeName={'/various-resource'} />}></Route>
                  <Route path='/resources' element={<Resources Header={'Resources'} routeName={'/resources'} />}></Route>
                  <Route path='/profile' element={<Profile Header={'Profile'} routeName={'/profile'} />}></Route>
                  <Route path='/customError' element={<CustomError Header={'CustomError'} routeName={'/customError'} />}></Route>
                  <Route path='/userNotFound' element={<UserNotFound Header={'UserNotFound'} routeName={'/userNotFound'} />}></Route>
                  <Route path='/companyNotFound' element={<CompanyNotFound Header={'CompanyNotFound'} routeName={'/companyNotFound'} />}></Route>
                </Route>
              </Routes>
            </Box>
          </HashRouter>
        </ThemeProvider>
      </DndProvider>
    </>

  );
}

export default App;
